import Api from "../../../../service";
import { SET_ERROR, SET_HOMENEWSCATEGORIES } from "./constants";

const setHomeNewsCategories = (data) => ({
  type: SET_HOMENEWSCATEGORIES,
  data,
});

const setError = (data) => ({
  type: SET_ERROR,
  data,
});

export const getHomeNewsCategories = (data) => (dispatch) =>
  Api.home
    .getHomeNewsCategories(data)
    .then((response) => {
      dispatch(setHomeNewsCategories(response));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error));
    });
